import FaqList from '../faq.json'

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": FaqList.map(faq => ({
    "@type": "Question",
    "name": faq.title,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer.join('')
    }
  }))
}
